/**
 * Created by tofael on 3/23/17.
 */
import React from 'react';
import apiConfig from './api-config';
import Group from 'material-ui/svg-icons/social/group';
import Call from 'material-ui/svg-icons/communication/call';
import Admins from 'material-ui/svg-icons/action/account-box';
import Missions from 'material-ui/svg-icons/action/assignment';
import Stats from 'material-ui/svg-icons/action/assessment';
import ActionSchedule from 'material-ui/svg-icons/action/schedule';

const config = {
  menus: {
    rmg: [
      { text: 'Doctors', icon: <Group/>, link: '/doctors' },
      { text: 'Doctors Online', icon: <Group/>, link: '/visiting-doctors'},
      { text: 'Controllers Online', icon: <Group/>, link: '/operators'},
      { text: 'Specialities', icon: <Missions/>, link: '/specialities'},
      { text: 'Missions', icon: <Missions/>, link: '/missions', state: 'list'},
    ],
    common: [
      { text: 'Schedules', icon: <ActionSchedule/>, link: '/schedules'},
      { text: 'Appointments', icon: <ActionSchedule/>, link: '/appointments'},
      { text: 'Specialities', icon: <Missions/>, link: '/specialities'}
    ],
    admin: [
      { text: 'Calls', icon: <Call/>, link: '/calls'},
      { text: 'Consumers', icon: <Group/>, link: '/consumers'},
      { text: 'Stats', icon: <Stats/>, link: '/stats'},
      { text: 'Attendance', icon: <ActionSchedule/>, link: '/attendance'},
      { text: 'Tips', icon: <Missions/>, link: '/tips'},
      { text: 'Pending Payments', icon: <Group/>, link: '/pending-payments'}
    ],
    super_admin:[
      { text: 'Admins', icon: <Admins/>, link: '/admins' }
    ]
  },
  urls: {
    api_url: apiConfig.api_url,
    doc_url: apiConfig.doc_url
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/utility/app-config.js